import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
export type MakeEmpty<T extends { [key: string]: unknown }, K extends keyof T> = {
	[_ in K]?: never;
};
export type Incremental<T> =
	| T
	| { [P in keyof T]?: P extends ' $fragmentName' | '__typename' ? T[P] : never };
const defaultOptions = {} as const;
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
	ID: { input: string; output: string };
	String: { input: string; output: string };
	Boolean: { input: boolean; output: boolean };
	Int: { input: number; output: number };
	Float: { input: number; output: number };
	/**
	 * The `Date` scalar type represents a date. The Date appears in a JSON
	 * response as an ISO8601 formatted string, without a time component.
	 */
	Date: { input: any; output: any };
	/**
	 * The `Decimal` scalar type represents signed double-precision fractional
	 * values parsed by the `Decimal` library. The Decimal appears in a JSON
	 * response as a string to preserve precision.
	 */
	Decimal: { input: any; output: any };
	/**
	 * The `Json` scalar type represents arbitrary json string data, represented as UTF-8
	 * character sequences. The Json type is most often used to represent a free-form
	 * human-readable json string.
	 */
	Json: { input: any; output: any };
};

export enum Country {
	Abw = 'ABW',
	Afg = 'AFG',
	Ago = 'AGO',
	Aia = 'AIA',
	Ala = 'ALA',
	Alb = 'ALB',
	And = 'AND',
	Ant = 'ANT',
	Are = 'ARE',
	Arg = 'ARG',
	Arm = 'ARM',
	Asm = 'ASM',
	Ata = 'ATA',
	Atf = 'ATF',
	Atg = 'ATG',
	Aus = 'AUS',
	Aut = 'AUT',
	Aze = 'AZE',
	Bdi = 'BDI',
	Bel = 'BEL',
	Ben = 'BEN',
	Bes = 'BES',
	Bfa = 'BFA',
	Bgd = 'BGD',
	Bgr = 'BGR',
	Bhr = 'BHR',
	Bhs = 'BHS',
	Bih = 'BIH',
	Blm = 'BLM',
	Blr = 'BLR',
	Blz = 'BLZ',
	Bmu = 'BMU',
	Bol = 'BOL',
	Bra = 'BRA',
	Brb = 'BRB',
	Brn = 'BRN',
	Btn = 'BTN',
	Bvt = 'BVT',
	Bwa = 'BWA',
	Caf = 'CAF',
	Can = 'CAN',
	Cck = 'CCK',
	Che = 'CHE',
	Chl = 'CHL',
	Chn = 'CHN',
	Civ = 'CIV',
	Cmr = 'CMR',
	Cod = 'COD',
	Cog = 'COG',
	Cok = 'COK',
	Col = 'COL',
	Com = 'COM',
	Cpv = 'CPV',
	Cri = 'CRI',
	Cub = 'CUB',
	Cuw = 'CUW',
	Cxr = 'CXR',
	Cym = 'CYM',
	Cyp = 'CYP',
	Cze = 'CZE',
	Deu = 'DEU',
	Dji = 'DJI',
	Dma = 'DMA',
	Dnk = 'DNK',
	Dom = 'DOM',
	Dza = 'DZA',
	Ecu = 'ECU',
	Egy = 'EGY',
	Eri = 'ERI',
	Esh = 'ESH',
	Esp = 'ESP',
	Est = 'EST',
	Eth = 'ETH',
	Fin = 'FIN',
	Fji = 'FJI',
	Flk = 'FLK',
	Fra = 'FRA',
	Fro = 'FRO',
	Fsm = 'FSM',
	Gab = 'GAB',
	Gbr = 'GBR',
	Geo = 'GEO',
	Ggy = 'GGY',
	Gha = 'GHA',
	Gib = 'GIB',
	Gin = 'GIN',
	Glp = 'GLP',
	Gmb = 'GMB',
	Gnb = 'GNB',
	Gnq = 'GNQ',
	Grc = 'GRC',
	Grd = 'GRD',
	Grl = 'GRL',
	Gtm = 'GTM',
	Guf = 'GUF',
	Gum = 'GUM',
	Guy = 'GUY',
	Hkg = 'HKG',
	Hmd = 'HMD',
	Hnd = 'HND',
	Hrv = 'HRV',
	Hti = 'HTI',
	Hun = 'HUN',
	Idn = 'IDN',
	Imn = 'IMN',
	Ind = 'IND',
	Iot = 'IOT',
	Irl = 'IRL',
	Irn = 'IRN',
	Irq = 'IRQ',
	Isl = 'ISL',
	Isr = 'ISR',
	Ita = 'ITA',
	Jam = 'JAM',
	Jey = 'JEY',
	Jor = 'JOR',
	Jpn = 'JPN',
	Kaz = 'KAZ',
	Ken = 'KEN',
	Kgz = 'KGZ',
	Khm = 'KHM',
	Kir = 'KIR',
	Kna = 'KNA',
	Kor = 'KOR',
	Kwt = 'KWT',
	Lao = 'LAO',
	Lbn = 'LBN',
	Lbr = 'LBR',
	Lby = 'LBY',
	Lca = 'LCA',
	Lie = 'LIE',
	Lka = 'LKA',
	Lso = 'LSO',
	Ltu = 'LTU',
	Lux = 'LUX',
	Lva = 'LVA',
	Mac = 'MAC',
	Maf = 'MAF',
	Mar = 'MAR',
	Mco = 'MCO',
	Mda = 'MDA',
	Mdg = 'MDG',
	Mdv = 'MDV',
	Mex = 'MEX',
	Mhl = 'MHL',
	Mkd = 'MKD',
	Mli = 'MLI',
	Mlt = 'MLT',
	Mmr = 'MMR',
	Mne = 'MNE',
	Mng = 'MNG',
	Mnp = 'MNP',
	Moz = 'MOZ',
	Mrt = 'MRT',
	Msr = 'MSR',
	Mtq = 'MTQ',
	Mus = 'MUS',
	Mwi = 'MWI',
	Mys = 'MYS',
	Myt = 'MYT',
	Nam = 'NAM',
	Ncl = 'NCL',
	Ner = 'NER',
	Nfk = 'NFK',
	Nga = 'NGA',
	Nic = 'NIC',
	Niu = 'NIU',
	Nld = 'NLD',
	Nor = 'NOR',
	Npl = 'NPL',
	Nru = 'NRU',
	Nzl = 'NZL',
	Omn = 'OMN',
	Pak = 'PAK',
	Pan = 'PAN',
	Pcn = 'PCN',
	Per = 'PER',
	Phl = 'PHL',
	Plw = 'PLW',
	Png = 'PNG',
	Pol = 'POL',
	Pri = 'PRI',
	Prk = 'PRK',
	Prt = 'PRT',
	Pry = 'PRY',
	Pse = 'PSE',
	Pyf = 'PYF',
	Qat = 'QAT',
	Reu = 'REU',
	Rou = 'ROU',
	Rus = 'RUS',
	Rwa = 'RWA',
	Sau = 'SAU',
	Sdn = 'SDN',
	Sen = 'SEN',
	Sgp = 'SGP',
	Sgs = 'SGS',
	Shn = 'SHN',
	Sjm = 'SJM',
	Slb = 'SLB',
	Sle = 'SLE',
	Slv = 'SLV',
	Smr = 'SMR',
	Som = 'SOM',
	Spm = 'SPM',
	Srb = 'SRB',
	Ssd = 'SSD',
	Stp = 'STP',
	Sur = 'SUR',
	Svk = 'SVK',
	Svn = 'SVN',
	Swe = 'SWE',
	Swz = 'SWZ',
	Sxm = 'SXM',
	Syc = 'SYC',
	Syr = 'SYR',
	Tca = 'TCA',
	Tcd = 'TCD',
	Tgo = 'TGO',
	Tha = 'THA',
	Tjk = 'TJK',
	Tkl = 'TKL',
	Tkm = 'TKM',
	Tls = 'TLS',
	Ton = 'TON',
	Tto = 'TTO',
	Tun = 'TUN',
	Tur = 'TUR',
	Tuv = 'TUV',
	Twn = 'TWN',
	Tza = 'TZA',
	Uga = 'UGA',
	Ukr = 'UKR',
	Umi = 'UMI',
	Ury = 'URY',
	Usa = 'USA',
	Uzb = 'UZB',
	Vat = 'VAT',
	Vct = 'VCT',
	Ven = 'VEN',
	Vgb = 'VGB',
	Vir = 'VIR',
	Vnm = 'VNM',
	Vut = 'VUT',
	Wlf = 'WLF',
	Wsm = 'WSM',
	Yem = 'YEM',
	Zaf = 'ZAF',
	Zmb = 'ZMB',
	Zwe = 'ZWE'
}

export enum HouseType {
	Family = 'FAMILY',
	Mortgaged = 'MORTGAGED',
	Owned = 'OWNED',
	Rented = 'RENTED'
}

/** A keyset page of :registry */
export type KeysetPageOfRegistry = {
	__typename?: 'KeysetPageOfRegistry';
	/** Total count on all pages */
	count?: Maybe<Scalars['Int']['output']>;
	/** The last keyset in the results */
	endKeyset?: Maybe<Scalars['String']['output']>;
	/** The records contained in the page */
	results?: Maybe<Array<Registry>>;
	/** The first keyset in the results */
	startKeyset?: Maybe<Scalars['String']['output']>;
};

export enum MaritalStatus {
	Married = 'MARRIED',
	Other = 'OTHER',
	Single = 'SINGLE'
}

export enum MexStates {
	Agu = 'AGU',
	Bcn = 'BCN',
	Bcs = 'BCS',
	Cam = 'CAM',
	Chh = 'CHH',
	Chp = 'CHP',
	Cmx = 'CMX',
	Coa = 'COA',
	Col = 'COL',
	Dur = 'DUR',
	Gro = 'GRO',
	Gua = 'GUA',
	Hid = 'HID',
	Jal = 'JAL',
	Mex = 'MEX',
	Mic = 'MIC',
	Mor = 'MOR',
	Nay = 'NAY',
	Nle = 'NLE',
	Oax = 'OAX',
	Pue = 'PUE',
	Que = 'QUE',
	Roo = 'ROO',
	Sin = 'SIN',
	Slp = 'SLP',
	Son = 'SON',
	Tab = 'TAB',
	Tam = 'TAM',
	Tla = 'TLA',
	Ver = 'VER',
	Yuc = 'YUC',
	Zac = 'ZAC'
}

export type Money = {
	__typename?: 'Money';
	amount: Scalars['Decimal']['output'];
	currency: Scalars['String']['output'];
};

export type MoneyInput = {
	amount: Scalars['Decimal']['input'];
	currency: Scalars['String']['input'];
};

/** An error generated by a failed mutation */
export type MutationError = {
	__typename?: 'MutationError';
	/** An error code for the given error */
	code?: Maybe<Scalars['String']['output']>;
	/** The field or fields that produced the error */
	fields?: Maybe<Array<Scalars['String']['output']>>;
	/** The human readable error message */
	message?: Maybe<Scalars['String']['output']>;
	/** A shorter error message, with vars not replaced */
	shortMessage?: Maybe<Scalars['String']['output']>;
	/** Replacements for the short message */
	vars?: Maybe<Scalars['Json']['output']>;
};

export enum Nationality {
	Mexican = 'MEXICAN'
}

export enum Occupation {
	GovernmentEmployee = 'GOVERNMENT_EMPLOYEE',
	Other = 'OTHER',
	PrivateSector = 'PRIVATE_SECTOR',
	Student = 'STUDENT'
}

export enum OfficialIdType {
	Ine = 'INE',
	Passport = 'PASSPORT'
}

export type RegisterBirthInformationInput = {
	birthInformation?: InputMaybe<RegistryBirthInformationInput>;
};

/** The result of the :register_birth_information mutation */
export type RegisterBirthInformationResult = {
	__typename?: 'RegisterBirthInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type RegisterEconomicInformationInput = {
	economicInformation?: InputMaybe<RegistryEconomicInformationInput>;
};

/** The result of the :register_economic_information mutation */
export type RegisterEconomicInformationResult = {
	__typename?: 'RegisterEconomicInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type RegisterOfficialAddressInput = {
	officialAddress?: InputMaybe<RegistryOfficialAddressInput>;
};

/** The result of the :register_official_address mutation */
export type RegisterOfficialAddressResult = {
	__typename?: 'RegisterOfficialAddressResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type RegisterPersonalInformationInput = {
	personalInformation?: InputMaybe<RegistryPersonalInformationInput>;
};

/** The result of the :register_personal_information mutation */
export type RegisterPersonalInformationResult = {
	__typename?: 'RegisterPersonalInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type RegisterTaxInformationInput = {
	taxInformation?: InputMaybe<RegistryTaxInformationInput>;
};

/** The result of the :register_tax_information mutation */
export type RegisterTaxInformationResult = {
	__typename?: 'RegisterTaxInformationResult';
	/** Any errors generated, if the mutation failed */
	errors: Array<MutationError>;
	/** The successful result of the mutation */
	result?: Maybe<Registry>;
};

export type Registry = {
	__typename?: 'Registry';
	birthInformation?: Maybe<RegistryBirthInformation>;
	clientId: Scalars['ID']['output'];
	economicInformation?: Maybe<RegistryEconomicInformation>;
	id: Scalars['ID']['output'];
	officialAddress?: Maybe<RegistryOfficialAddress>;
	personalInformation?: Maybe<RegistryPersonalInformation>;
	status: RegistryStatus;
	taxInformation?: Maybe<RegistryTaxInformation>;
};

export type RegistryBirthInformation = {
	__typename?: 'RegistryBirthInformation';
	countryOfBirth: Country;
	dateOfBirth: Scalars['Date']['output'];
	nationality: Nationality;
	stateOfBirth?: Maybe<MexStates>;
};

export type RegistryBirthInformationInput = {
	countryOfBirth?: InputMaybe<Country>;
	dateOfBirth?: InputMaybe<Scalars['Date']['input']>;
	nationality?: InputMaybe<Nationality>;
	stateOfBirth?: InputMaybe<MexStates>;
};

export type RegistryEconomicInformation = {
	__typename?: 'RegistryEconomicInformation';
	extraMonthlyIncome: Money;
	houseType: HouseType;
	monthlyFamilyExpense: Money;
	monthlyFamilyIncome: Money;
	occupation: Occupation;
};

export type RegistryEconomicInformationInput = {
	extraMonthlyIncome?: InputMaybe<MoneyInput>;
	houseType?: InputMaybe<HouseType>;
	monthlyFamilyExpense?: InputMaybe<MoneyInput>;
	monthlyFamilyIncome?: InputMaybe<MoneyInput>;
	occupation?: InputMaybe<Occupation>;
};

export type RegistryFilterClientId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RegistryFilterId = {
	eq?: InputMaybe<Scalars['ID']['input']>;
	greaterThan?: InputMaybe<Scalars['ID']['input']>;
	greaterThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	in?: InputMaybe<Array<Scalars['ID']['input']>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<Scalars['ID']['input']>;
	lessThanOrEqual?: InputMaybe<Scalars['ID']['input']>;
	notEq?: InputMaybe<Scalars['ID']['input']>;
};

export type RegistryFilterInput = {
	and?: InputMaybe<Array<RegistryFilterInput>>;
	clientId?: InputMaybe<RegistryFilterClientId>;
	id?: InputMaybe<RegistryFilterId>;
	not?: InputMaybe<Array<RegistryFilterInput>>;
	or?: InputMaybe<Array<RegistryFilterInput>>;
	status?: InputMaybe<RegistryFilterStatus>;
};

export type RegistryFilterStatus = {
	eq?: InputMaybe<RegistryStatus>;
	greaterThan?: InputMaybe<RegistryStatus>;
	greaterThanOrEqual?: InputMaybe<RegistryStatus>;
	in?: InputMaybe<Array<RegistryStatus>>;
	isNil?: InputMaybe<Scalars['Boolean']['input']>;
	lessThan?: InputMaybe<RegistryStatus>;
	lessThanOrEqual?: InputMaybe<RegistryStatus>;
	notEq?: InputMaybe<RegistryStatus>;
};

export type RegistryOfficialAddress = {
	__typename?: 'RegistryOfficialAddress';
	city: Scalars['String']['output'];
	colony: Scalars['String']['output'];
	externalNumber: Scalars['String']['output'];
	internalNumber?: Maybe<Scalars['String']['output']>;
	municipalityOrDelegation: Scalars['String']['output'];
	postalCode: Scalars['String']['output'];
	state: MexStates;
	street: Scalars['String']['output'];
};

export type RegistryOfficialAddressInput = {
	city?: InputMaybe<Scalars['String']['input']>;
	colony?: InputMaybe<Scalars['String']['input']>;
	externalNumber?: InputMaybe<Scalars['String']['input']>;
	internalNumber?: InputMaybe<Scalars['String']['input']>;
	municipalityOrDelegation?: InputMaybe<Scalars['String']['input']>;
	postalCode?: InputMaybe<Scalars['String']['input']>;
	state?: InputMaybe<MexStates>;
	street?: InputMaybe<Scalars['String']['input']>;
};

export type RegistryPersonalInformation = {
	__typename?: 'RegistryPersonalInformation';
	curp: Scalars['String']['output'];
	firstLastName: Scalars['String']['output'];
	hasChildren: Scalars['Boolean']['output'];
	maritalStatus: MaritalStatus;
	name: Scalars['String']['output'];
	secondLastName?: Maybe<Scalars['String']['output']>;
};

export type RegistryPersonalInformationInput = {
	curp?: InputMaybe<Scalars['String']['input']>;
	firstLastName?: InputMaybe<Scalars['String']['input']>;
	hasChildren?: InputMaybe<Scalars['Boolean']['input']>;
	maritalStatus?: InputMaybe<MaritalStatus>;
	name?: InputMaybe<Scalars['String']['input']>;
	secondLastName?: InputMaybe<Scalars['String']['input']>;
};

export enum RegistrySortField {
	ClientId = 'CLIENT_ID',
	Id = 'ID',
	Status = 'STATUS'
}

export type RegistrySortInput = {
	field: RegistrySortField;
	order?: InputMaybe<SortOrder>;
};

export enum RegistryStatus {
	BirthInformationRegistered = 'BIRTH_INFORMATION_REGISTERED',
	Completed = 'COMPLETED',
	Created = 'CREATED',
	OfficialAddressRegistered = 'OFFICIAL_ADDRESS_REGISTERED',
	PersonalInformationRegistered = 'PERSONAL_INFORMATION_REGISTERED',
	TaxInformationRegistered = 'TAX_INFORMATION_REGISTERED'
}

export type RegistryTaxInformation = {
	__typename?: 'RegistryTaxInformation';
	clabe?: Maybe<Scalars['String']['output']>;
	eSignatureSerialNumber?: Maybe<Scalars['String']['output']>;
	officialIdType: OfficialIdType;
	rfc: Scalars['String']['output'];
	taxRegimeCode: TaxRegimeCode;
};

export type RegistryTaxInformationInput = {
	clabe?: InputMaybe<Scalars['String']['input']>;
	eSignatureSerialNumber?: InputMaybe<Scalars['String']['input']>;
	officialIdType?: InputMaybe<OfficialIdType>;
	rfc?: InputMaybe<Scalars['String']['input']>;
	taxRegimeCode?: InputMaybe<TaxRegimeCode>;
};

export type RootMutationType = {
	__typename?: 'RootMutationType';
	registerBirthInformation: RegisterBirthInformationResult;
	registerEconomicInformation: RegisterEconomicInformationResult;
	registerOfficialAddress: RegisterOfficialAddressResult;
	registerPersonalInformation: RegisterPersonalInformationResult;
	registerTaxInformation: RegisterTaxInformationResult;
};

export type RootMutationTypeRegisterBirthInformationArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<RegisterBirthInformationInput>;
};

export type RootMutationTypeRegisterEconomicInformationArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<RegisterEconomicInformationInput>;
};

export type RootMutationTypeRegisterOfficialAddressArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<RegisterOfficialAddressInput>;
};

export type RootMutationTypeRegisterPersonalInformationArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<RegisterPersonalInformationInput>;
};

export type RootMutationTypeRegisterTaxInformationArgs = {
	id: Scalars['ID']['input'];
	input?: InputMaybe<RegisterTaxInformationInput>;
};

export type RootQueryType = {
	__typename?: 'RootQueryType';
	getMyRegistry?: Maybe<Registry>;
	getRegistry?: Maybe<Registry>;
	listRegistries?: Maybe<KeysetPageOfRegistry>;
	/**
	 * Hello! This is a sample query to verify that AshGraphql has been set up correctly.
	 * Remove me once you have a query of your own!
	 */
	sayHello?: Maybe<Scalars['String']['output']>;
};

export type RootQueryTypeGetMyRegistryArgs = {
	filter?: InputMaybe<RegistryFilterInput>;
};

export type RootQueryTypeGetRegistryArgs = {
	id: Scalars['ID']['input'];
};

export type RootQueryTypeListRegistriesArgs = {
	after?: InputMaybe<Scalars['String']['input']>;
	before?: InputMaybe<Scalars['String']['input']>;
	filter?: InputMaybe<RegistryFilterInput>;
	first?: InputMaybe<Scalars['Int']['input']>;
	last?: InputMaybe<Scalars['Int']['input']>;
	sort?: InputMaybe<Array<InputMaybe<RegistrySortInput>>>;
};

export enum SortOrder {
	Asc = 'ASC',
	AscNullsFirst = 'ASC_NULLS_FIRST',
	AscNullsLast = 'ASC_NULLS_LAST',
	Desc = 'DESC',
	DescNullsFirst = 'DESC_NULLS_FIRST',
	DescNullsLast = 'DESC_NULLS_LAST'
}

export enum TaxRegimeCode {
	Code_605 = 'CODE_605',
	Code_606 = 'CODE_606',
	Code_608 = 'CODE_608',
	Code_611 = 'CODE_611',
	Code_612 = 'CODE_612',
	Code_614 = 'CODE_614',
	Code_615 = 'CODE_615',
	Code_616 = 'CODE_616',
	Code_621 = 'CODE_621',
	Code_622 = 'CODE_622',
	Code_626 = 'CODE_626',
	Code_629 = 'CODE_629',
	Code_630 = 'CODE_630'
}

export type GetRegistriesQueryVariables = Exact<{ [key: string]: never }>;

export type GetRegistriesQuery = {
	__typename?: 'RootQueryType';
	listRegistries?: { __typename?: 'KeysetPageOfRegistry'; count?: number | null } | null;
};

export type GetClientProspectQueryVariables = Exact<{
	id: Scalars['ID']['input'];
}>;

export type GetClientProspectQuery = {
	__typename?: 'RootQueryType';
	getRegistry?: {
		__typename?: 'Registry';
		status: RegistryStatus;
		economicInformation?: {
			__typename?: 'RegistryEconomicInformation';
			occupation: Occupation;
		} | null;
		birthInformation?: {
			__typename?: 'RegistryBirthInformation';
			dateOfBirth: any;
			stateOfBirth?: MexStates | null;
			countryOfBirth: Country;
			nationality: Nationality;
		} | null;
		personalInformation?: {
			__typename?: 'RegistryPersonalInformation';
			name: string;
			firstLastName: string;
			secondLastName?: string | null;
			hasChildren: boolean;
			maritalStatus: MaritalStatus;
			curp: string;
		} | null;
		taxInformation?: { __typename?: 'RegistryTaxInformation'; rfc: string } | null;
	} | null;
};

export type GetClientsProspectusQueryVariables = Exact<{ [key: string]: never }>;

export type GetClientsProspectusQuery = {
	__typename?: 'RootQueryType';
	listRegistries?: {
		__typename?: 'KeysetPageOfRegistry';
		results?: Array<{
			__typename?: 'Registry';
			id: string;
			status: RegistryStatus;
			personalInformation?: {
				__typename?: 'RegistryPersonalInformation';
				name: string;
				firstLastName: string;
			} | null;
			birthInformation?: {
				__typename?: 'RegistryBirthInformation';
				stateOfBirth?: MexStates | null;
			} | null;
		}> | null;
	} | null;
};

export const GetRegistriesDocument = gql`
	query GetRegistries {
		listRegistries {
			count
		}
	}
`;

/**
 * __useGetRegistriesQuery__
 *
 * To run a query within a React component, call `useGetRegistriesQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetRegistriesQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetRegistriesQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetRegistriesQuery(
	baseOptions?: Apollo.QueryHookOptions<GetRegistriesQuery, GetRegistriesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetRegistriesQuery, GetRegistriesQueryVariables>(
		GetRegistriesDocument,
		options
	);
}
export function useGetRegistriesLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetRegistriesQuery, GetRegistriesQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetRegistriesQuery, GetRegistriesQueryVariables>(
		GetRegistriesDocument,
		options
	);
}
export function useGetRegistriesSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetRegistriesQuery, GetRegistriesQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetRegistriesQuery, GetRegistriesQueryVariables>(
		GetRegistriesDocument,
		options
	);
}
export type GetRegistriesQueryHookResult = ReturnType<typeof useGetRegistriesQuery>;
export type GetRegistriesLazyQueryHookResult = ReturnType<typeof useGetRegistriesLazyQuery>;
export type GetRegistriesSuspenseQueryHookResult = ReturnType<typeof useGetRegistriesSuspenseQuery>;
export type GetRegistriesQueryResult = Apollo.QueryResult<
	GetRegistriesQuery,
	GetRegistriesQueryVariables
>;
export const GetClientProspectDocument = gql`
	query GetClientProspect($id: ID!) {
		getRegistry(id: $id) {
			economicInformation {
				occupation
			}
			birthInformation {
				dateOfBirth
				stateOfBirth
				countryOfBirth
				nationality
			}
			personalInformation {
				name
				firstLastName
				secondLastName
				hasChildren
				maritalStatus
				curp
			}
			status
			taxInformation {
				rfc
			}
		}
	}
`;

/**
 * __useGetClientProspectQuery__
 *
 * To run a query within a React component, call `useGetClientProspectQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientProspectQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientProspectQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useGetClientProspectQuery(
	baseOptions: Apollo.QueryHookOptions<GetClientProspectQuery, GetClientProspectQueryVariables> &
		({ variables: GetClientProspectQueryVariables; skip?: boolean } | { skip: boolean })
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetClientProspectQuery, GetClientProspectQueryVariables>(
		GetClientProspectDocument,
		options
	);
}
export function useGetClientProspectLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<GetClientProspectQuery, GetClientProspectQueryVariables>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetClientProspectQuery, GetClientProspectQueryVariables>(
		GetClientProspectDocument,
		options
	);
}
export function useGetClientProspectSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetClientProspectQuery, GetClientProspectQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetClientProspectQuery, GetClientProspectQueryVariables>(
		GetClientProspectDocument,
		options
	);
}
export type GetClientProspectQueryHookResult = ReturnType<typeof useGetClientProspectQuery>;
export type GetClientProspectLazyQueryHookResult = ReturnType<typeof useGetClientProspectLazyQuery>;
export type GetClientProspectSuspenseQueryHookResult = ReturnType<
	typeof useGetClientProspectSuspenseQuery
>;
export type GetClientProspectQueryResult = Apollo.QueryResult<
	GetClientProspectQuery,
	GetClientProspectQueryVariables
>;
export const GetClientsProspectusDocument = gql`
	query GetClientsProspectus {
		listRegistries {
			results {
				id
				personalInformation {
					name
					firstLastName
				}
				birthInformation {
					stateOfBirth
				}
				status
			}
		}
	}
`;

/**
 * __useGetClientsProspectusQuery__
 *
 * To run a query within a React component, call `useGetClientsProspectusQuery` and pass it any options that fit your needs.
 * When your component renders, `useGetClientsProspectusQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useGetClientsProspectusQuery({
 *   variables: {
 *   },
 * });
 */
export function useGetClientsProspectusQuery(
	baseOptions?: Apollo.QueryHookOptions<
		GetClientsProspectusQuery,
		GetClientsProspectusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useQuery<GetClientsProspectusQuery, GetClientsProspectusQueryVariables>(
		GetClientsProspectusDocument,
		options
	);
}
export function useGetClientsProspectusLazyQuery(
	baseOptions?: Apollo.LazyQueryHookOptions<
		GetClientsProspectusQuery,
		GetClientsProspectusQueryVariables
	>
) {
	const options = { ...defaultOptions, ...baseOptions };
	return Apollo.useLazyQuery<GetClientsProspectusQuery, GetClientsProspectusQueryVariables>(
		GetClientsProspectusDocument,
		options
	);
}
export function useGetClientsProspectusSuspenseQuery(
	baseOptions?:
		| Apollo.SkipToken
		| Apollo.SuspenseQueryHookOptions<GetClientsProspectusQuery, GetClientsProspectusQueryVariables>
) {
	const options =
		baseOptions === Apollo.skipToken ? baseOptions : { ...defaultOptions, ...baseOptions };
	return Apollo.useSuspenseQuery<GetClientsProspectusQuery, GetClientsProspectusQueryVariables>(
		GetClientsProspectusDocument,
		options
	);
}
export type GetClientsProspectusQueryHookResult = ReturnType<typeof useGetClientsProspectusQuery>;
export type GetClientsProspectusLazyQueryHookResult = ReturnType<
	typeof useGetClientsProspectusLazyQuery
>;
export type GetClientsProspectusSuspenseQueryHookResult = ReturnType<
	typeof useGetClientsProspectusSuspenseQuery
>;
export type GetClientsProspectusQueryResult = Apollo.QueryResult<
	GetClientsProspectusQuery,
	GetClientsProspectusQueryVariables
>;
